import { memo } from 'react';
import { ModalOverlayProps } from './ModalOverlay.types';
import PressableOverlay from '../../PressableOverlay/PressableOverlay';
import Box from '../../Box/Box';

function ModalOverlay(props: ModalOverlayProps) {
  return (
    <PressableOverlay pointerEvents="auto" {...props}>
      <Box backgroundColor="backdropSecondary" absoluteFill />
    </PressableOverlay>
  );
}

export default memo(ModalOverlay);
